import React from 'react'

const Title = ({ title, des }) => {
  return (
    <div className="flex flex-col gap-3 font-titleFont mb-14">
      <div style={{ display: "flex", alignItems: "center", gap: "10px", justifyContent: "center" }}>
        <span style={{
          width: "24px", height: "1px",
          background: "#ff014f",
          display: "inline-block"
        }} />
        <h3 style={{
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: "11px",
          letterSpacing: "0.15em",
          color: "#ff014f",
          textTransform: "uppercase",
          fontWeight: 400,
        }}>
          {title}
        </h3>
        <span style={{
          width: "24px", height: "1px",
          background: "#ff014f",
          display: "inline-block"
        }} />
      </div>
      <h1 style={{
        fontFamily: "'Syne', sans-serif",
        fontSize: "clamp(2rem, 5vw, 3.5rem)",
        fontWeight: 800,
        color: "#f0f2f5",
        lineHeight: 1.1,
        letterSpacing: "-0.02em",
        textAlign: "center",
      }}>
        {des}
      </h1>
    </div>
  );
}

export default Title;